import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "predictive-search-result-query",
  class PredictiveSearchResultQuery extends WYATTElement {
    constructor() {
      super();

      this.data = JSON.parse(this.dataset.query);
      this.button = this.querySelector("button");
      this.text = this.querySelector('[data-template-element="text"]');
      this.form = this.closest("form");
      this.input = this.form.querySelector("[name='q']");

      this.setText();

      this.button.addEventListener("click", this.handleClick.bind(this));
    }

    setText() {
      const { text, type, completed } = this.data;

      if (type === "exact") {
        this.text.innerHTML = `<strong>${text}</strong>`;
      } else if (completed?.length === 1) {
        const { token, query } = completed[0];

        this.text.innerHTML = token.replace(query, `<strong>${query}</strong>`);
      } else {
        this.text.innerHTML = text;
      }
    }

    handleClick(event) {
      event.preventDefault();

      this.input.value = this.data.text;
      this.form.submit();
    }
  },
);
